import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { request, METHOD } from '@/utils/request';
export function queryFlowCopyMan(_x, _x2, _x3) {
  return _queryFlowCopyMan.apply(this, arguments);
}
function _queryFlowCopyMan() {
  _queryFlowCopyMan = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(page, limit, param) {
    var data;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          data = {
            currentNo: page,
            pageSize: limit,
            isRead: param.isRead,
            cateName: param.type,
            formName: param.formName
          };
          return _context.a(2, request('/flow/queryFlowCopyMan', METHOD.POST, data));
      }
    }, _callee);
  }));
  return _queryFlowCopyMan.apply(this, arguments);
}